import { render, staticRenderFns } from "./VideoCallView.vue?vue&type=template&id=54f331c1&"
import script from "./VideoCallView.vue?vue&type=script&lang=js&"
export * from "./VideoCallView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports